<template>
	<div class="operations-report" style="--report-grid-gap: 10px">
		<!-- 报告标题 -->
		<report-title :type="data.reportType" :date="data.startTime" />
		<!-- 设备监测状况 -->
		<DeviceSection :type="data.reportType" :data="data" />

		<!-- 通信分析 -->
		<CommunicationSection :type="data.reportType" :data="data" />

		<!-- 告警监控 -->
		<AlarmSection :type="data.reportType" :data="data" />
	</div>
</template>

<script>
import ReportTitle from './components/reportTitle.vue'
import DeviceSection from './report-section/device.vue'
import CommunicationSection from './report-section/communication.vue'
import AlarmSection from './report-section/alarm.vue'

export default {
	name: 'OperationsReport',
	components: {
		ReportTitle,
		DeviceSection,
		CommunicationSection,
		AlarmSection,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {}
	},
	methods: {},
	computed: {},
}
</script>

<style lang="scss" scoped>
.operations-report {
	width: 210mm; /* A4宽度 */
	min-height: 297mm; /* A4高度 */
	margin: 0 auto;
	padding: 10mm; /* 出血边距 - 增加为10mm以适应A4打印 */
	background: #ffffff;
	box-sizing: border-box;
	font-family: 'Source Han Sans CN', 'Microsoft YaHei', Arial, sans-serif;
	font-size: 10px;
	line-height: 1.5;

	/* 报告部分 */
	::v-deep .report-section {
		margin-bottom: var(--report-grid-gap);
		page-break-inside: avoid;
	}

	/* 统计网格 */
	::v-deep .stats-grid {
		display: flex;
		justify-content: space-between;
		gap: var(--report-grid-gap);
	}

	/* 图表布局 */
	::v-deep .charts-row {
		display: flex;
		gap: var(--report-grid-gap);
	}

	/* 响应式设计 */
	@media print {
		.operations-report {
			width: 100%;
			margin: 0;
			padding: 5mm; /* 打印时减小内边距 */
			box-shadow: none;
			page-break-after: always;
		}

		.operations-report:last-child {
			page-break-after: avoid;
		}

		::v-deep .report-section {
			page-break-inside: avoid;
			page-break-after: auto;
		}

		::v-deep .charts-row {
			page-break-inside: avoid;
		}

		::v-deep .table-container {
			page-break-inside: avoid;
		}

		/* 强制打印背景色 */
		* {
			-webkit-print-color-adjust: exact !important;
			print-color-adjust: exact !important;
		}
	}
}
</style>
